import { useEffect } from 'react'
import { type QliroOrder } from 'ecosystem'
import { useDispatch, useSelector } from 'shared-redux'
import { cleanCart, selectedCart } from 'shared-redux/state'
import { QliroCheckout } from '../QliroCheckout'

type QliroConfirmationProps = {
  qliroData: QliroOrder
  onConfirmPurchase: () => void
}

export const QliroConfirmation = ({ qliroData, onConfirmPurchase }: QliroConfirmationProps) => {
  const dispatch = useDispatch()
  const { cartStateUuid } = useSelector(selectedCart)

  useEffect(() => {
    if (!qliroData) {
      return
    }

    onConfirmPurchase()
  }, [qliroData, onConfirmPurchase])

  // Clean cart after payment confirmation, only if the cart is the same as it was on during checkout process
  useEffect(() => {
    const merchantDataCartStateUuid = qliroData?.MerchantProvidedMetadata?.[0].Value

    if (
      qliroData?.CustomerCheckoutStatus !== 'Completed' ||
      !cartStateUuid ||
      !merchantDataCartStateUuid
    ) {
      return
    }

    try {
      if (merchantDataCartStateUuid === cartStateUuid) {
        dispatch(cleanCart())
      }
    } catch {
      void 0
    }
  }, [
    cartStateUuid,
    dispatch,
    qliroData?.CustomerCheckoutStatus,
    qliroData.MerchantProvidedMetadata
  ])

  if (!qliroData) {
    return null
  }

  return <QliroCheckout qliroOrder={qliroData} />
}
